import styled from "styled-components";

const ThemedHeader = styled.h2`
  color: #0b3948;
`;

export default function PageHeader({ children }) {
  return <ThemedHeader>{children}</ThemedHeader>;
}
